import { ref as t, computed as x } from "vue";
const n = t(0), o = () => {
  const e = x(() => 2e3 + n.value);
  return {
    initialZIndex: 2e3,
    currentZIndex: e,
    nextZIndex: () => (n.value++, e.value)
  };
};
export {
  o as useZIndex
};
